import axiosInstance from "./axiosConfig";

export interface SitePageContent {
  heading?: string;
  text?: string;
  blocks?: SiteBlock[];
}

export interface SiteBlock { type: "cover" | "heading" | "text" | "image" | "button" | "features" | "columns" | "documents" | "contacts" | "divider"; title: string; text: string; asset_ids: number[]; button_label?: string; button_url?: string; items?: string[]; }
export interface SiteAsset { id: number; name: string; url: string; }

export interface SchoolSite {
  slug: string;
  title: string;
  main_page: SitePageContent;
  education_page: SitePageContent;
  is_published: boolean;
  url: string;
  address_certificate?: string | null;
  certificates?: SiteCertificate[];
  assets?: SiteAsset[];
  application_email?: string;
  legal_documents?: Record<string, number | null>;
  can_add_site_blocks?: boolean;
}

export interface SiteCertificate {
  id: number;
  document_number: string;
  generated_at: string;
  url: string;
}

export const fetchMySite = async (): Promise<SchoolSite | null> =>
  (await axiosInstance.get("sites/mine/")).data;

export const saveMySite = async (site: Partial<SchoolSite>): Promise<SchoolSite> =>
  (await axiosInstance.put("sites/mine/", site)).data;

export const publishMySite = async (): Promise<SchoolSite & { email_sent: boolean }> =>
  (await axiosInstance.post("sites/mine/publish/")).data;

export const createSiteCertificate = async (): Promise<SiteCertificate> =>
  (await axiosInstance.post("sites/mine/certificate/")).data;

export const uploadSiteAsset = async (file: File) => {
  const body = new FormData();
  body.append("file", file);
  return (await axiosInstance.post("sites/mine/assets/", body)).data;
};

export const fetchPublicSite = async (slug: string): Promise<SchoolSite> =>
  (await axiosInstance.get(`sites/public/${encodeURIComponent(slug)}/`)).data;

export interface SchoolSiteLeadPayload {
  name: string;
  email: string;
  phone?: string;
  message?: string;
  personal_data_consent: boolean;
  privacy_policy_consent: boolean;
  marketing_consent: boolean;
  website?: string;
}

export const submitSchoolSiteLead = async (slug: string, payload: SchoolSiteLeadPayload) =>
  (await axiosInstance.post(`sites/public/${encodeURIComponent(slug)}/applications/`, payload)).data;
